const { h, render, Component } = require('preact');
const queryString = require('qs')
const Web2018Helper = require('../../../helper')
const SupportAPIHelper = require('../../../../../support/frontend/helpers/API')

class CallbackTime extends Component {
  constructor(props) {
    super(props);
    this.configFromDom = Groupon.Utils.getConfigFromDom();
  }

  getCustomerRating(){
    let customerRating = null;
    if (this.configFromDom.user){
      try{
        customerRating = JSON.parse(this.configFromDom.user).customerRating
      }
      catch(err){
        customerRating = null
      }
    }
    return customerRating
  }

  setRating(params){
    if (Web2018Helper.isFeatureFlagEnabled('shouldEnableSBR') && Web2018Helper.isExperimentEnabled('shouldEnableSBR')){
      let customerRating = this.getCustomerRating();
      if (customerRating && customerRating > 0){
        params.customer_rating = customerRating;
      }
    }
    return params
  }

  getParamsForSelectedItem(params, selectedItem){
    if(selectedItem.claimId){
      params.is_clo_deal = true
    }
    else{
      if (selectedItem.DEAL_TYPE)
        params.deal_type = selectedItem.DEAL_TYPE
      if(selectedItem.inventoryServiceId)
        params.inventory_service_id = selectedItem.inventoryServiceId
      if(Web2018Helper.isFeatureFlagEnabled('costco') && selectedItem.isCostcoDeal)
        params.is_costco_deal = true
      if(selectedItem.isHBWDeal)
        params.is_hbw_deal = true
      if(selectedItem.isHEBDeal)
        params.is_heb_deal = true
    }
    return params
  }

  getQueryParamsForWaitTimeFetch(props){
    let params = {}
    params.callback_locale = props.locale
    params.country_code = I18n.country
    params = this.setRating(params)
    if(props.selectedItem){
      params = this.getParamsForSelectedItem(params, props.selectedItem)
    }
    let qs = queryString.stringify(params)
    return qs
  }

  getUrlForWaitTimeFetch(props){
    let qs = this.getQueryParamsForWaitTimeFetch(props)
    return `${this.configFromDom.SUPPORTBASEURL}/hold_time/fetch?${qs}`
  }

  setWaitTimeState(props){
    let defaultWaitTime = I18n.translate('js.modules.support.one_hour');
    let errorCb = () => {
      this.setState({"waitTime": defaultWaitTime});
    }
    let successCb = (response) => {
      if (response && response.estWaitTime){
        this.setState({"waitTime": response.estWaitTime});
      }
      else{
        this.setState({"waitTime": defaultWaitTime});
      }
    }
    let url = this.getUrlForWaitTimeFetch(props);
    SupportAPIHelper.get(url, null, successCb, errorCb, false);
  }

  componentDidMount() {
    this.setWaitTimeState(this.props);
  }

  componentWillReceiveProps(props){
    if(props.locale !== this.props.locale)
      this.setWaitTimeState(props);
  }

  render() {
    if(this.state.waitTime){
      return (
        <div class="response-time-section">
          <span class="icon-now"></span>
          <span class="estimated-response-time">
            {I18n.translate("js.modules.support.approximate_hold_time")} <span class="time-in-bold">{this.state.waitTime}</span>
          </span>
        </div>
      )
    }
    return null;
  }
}

module.exports = CallbackTime
